var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4213 0.683594C16.3951 0.683594 0.105469 16.9732 0.105469 36.9994C0.105469 57.0256 16.3951 73.3152 36.4213 73.3152C56.4474 73.3152 72.7371 57.0256 72.7371 36.9994C72.7371 16.9732 56.4474 0.683594 36.4213 0.683594ZM36.4213 5.87187C53.6435 5.87187 67.5491 19.7778 67.5491 36.9997C67.5491 54.2219 53.6432 68.1275 36.4213 68.1275C19.1994 68.1275 5.29344 54.2216 5.29344 36.9997C5.29344 19.7775 19.1994 5.87187 36.4213 5.87187ZM27.2342 20.571C25.2355 20.6162 23.5026 22.2212 23.4513 24.5161V49.4554C23.5195 52.5145 26.5745 54.3704 29.2608 52.9138L50.8773 40.4035C52.0541 39.7202 52.8495 38.4662 52.8495 36.9988C52.8495 35.5319 52.0534 34.2774 50.8773 33.594L29.2608 21.0837C28.5889 20.7194 27.9007 20.5559 27.2342 20.571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/PlayVideoIcon.f8c91b7abec8ff14a75fd7b0470c9b49.svg";
export { ForwardRef as ReactComponent };